import React from "react";
import RegisterPage, { STATUS_BADGES, PRIORITY_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const TYPE_BADGES = {
  "Unsafe Act": { bg: "#FEE2E2", color: "#7F1D1D" },
  "Unsafe Condition": { bg: "#FFE4E6", color: "#9F1239" },
  "Positive Observation": { bg: "#DCFCE7", color: "#166534" },
  Environmental: { bg: "#DBEAFE", color: "#1E40AF" },
  Safe: { bg: "#DCFCE7", color: "#166534" },
};

export default function Observations() {
  const { data, siteNames } = useHSE();
  const rows = data.observations || [];
  const raised = rows.length;
  const closed = rows.filter((o) => o.status === "Closed").length;
  const open = rows.filter((o) => o.status === "Open" || o.status === "In Progress").length;
  const sorOpen = rows.filter((o) => o.sorId && o.status !== "Closed").length;

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      <StatCard label="Total Raised" value={raised} testid="obs-total" />
      <StatCard label="Closed" value={closed} tone="safe" />
      <StatCard label="Open" value={open} tone="warning" />
      <StatCard label="SOR Open" value={sorOpen} tone="critical" />
      <StatCard label="Positive" value={rows.filter((o) => o.type === "Positive Observation").length} tone="info" />
    </div>
  );

  return (
    <RegisterPage
      title="Observations / SOR"
      subtitle="Safety observation reports — Unsafe Act · Unsafe Condition · Positive Observation with Action Plan linkage"
      storeKey="observations"
      idPrefix="OBS"
      topPanels={Top}
      columns={[
        { key: "id", label: "Obs ID" },
        { key: "sorId", label: "SOR ID" },
        { key: "date", label: "Date" },
        { key: "site", label: "Site" },
        { key: "area", label: "Area" },
        { key: "raisedBy", label: "Raised By" },
        { key: "contractor", label: "Contractor" },
        { key: "type", label: "Type" },
        { key: "category", label: "Category" },
        { key: "risk", label: "Risk" },
        { key: "linkedActionId", label: "Linked Action", render: (r) => r.linkedActionId ? <span className="font-mono text-[11px] text-[#18B84F]">{r.linkedActionId}</span> : <span className="text-slate-300">—</span> },
        { key: "responsible", label: "Responsible" },
        { key: "dueDate", label: "Due" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ type: TYPE_BADGES, risk: PRIORITY_BADGES, status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Observation ID" },
        { key: "sorId", label: "SOR ID (if applicable)" },
        { key: "date", label: "Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "area", label: "Area" },
        { key: "raisedBy", label: "Raised By" },
        { key: "contractor", label: "Contractor", type: "select", options: data.settings.contractors },
        { key: "type", label: "Type", type: "select", options: ["Unsafe Act", "Unsafe Condition", "Positive Observation", "Environmental"] },
        { key: "category", label: "Category", type: "select", options: data.settings.obsCategories },
        { key: "risk", label: "Risk Rating", type: "select", options: ["Low", "Medium", "High", "Critical"] },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "immediateAction", label: "Immediate Action", type: "textarea", full: true },
        { key: "responsible", label: "Responsible Person" },
        { key: "dueDate", label: "Due Date", type: "date" },
        { key: "closureDate", label: "Closure Date", type: "date" },
        { key: "beforePhoto", label: "Before Photo (reference)" },
        { key: "afterPhoto", label: "After Photo (reference)" },
        { key: "linkedActionId", label: "Linked Action ID" },
        { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed"] },
      ]}
    />
  );
}
